<template>
  <div>
    <v-layout>
      <v-flex xs12 sm6> Expired Date </v-flex>
      <v-flex xs12 sm6 class="text-xs-right">
        <template v-if="!loading">
          <DatepickerCustomDialog v-model="input">
            <div class="d-flex">
              <v-text-field
                type="text"
                :value="handleGetDateFormatted(input)"
                placeholder="เลือกวันที่"
                readonly
                outline
                hide-details
              ></v-text-field>
            </div>
          </DatepickerCustomDialog>
        </template>
      </v-flex>
    </v-layout>
    <div class="text-xs-center mt-2 mb-2">
      <v-btn outline color="grey" @click="$emit('onCancel')">{{ $t('cancel') }} </v-btn>
      <v-btn depressed color="primary" @click="$emit('onChangeConfig', input)">
        {{ $t('Save') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DatepickerCustomDialog from '@/components/elements/DatepickerCustomDialog.vue'
import { DATETIME } from '@/constants/datetime.js'

import dayjs from 'dayjs'
export default {
  components: {
    DatepickerCustomDialog
  },
  props: ['value'],
  data() {
    return {
      isEdit: false,
      input: '',
      loading: true
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    this.loading = true
    this.input = this.value
    this.loading = false
  },
  methods: {
    handleGetDateFormatted(value) {
      return value ? dayjs(value).format(DATETIME.DATE_FORMAT_DISPLAY) : ''
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/AdvancedSetting/ExpiredConfigManage.vue